/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/* eslint-env browser */

import isNil from 'lodash/isNil';

/**
 * Správce automatického restartu zařízení, který poskytuje rozhraní
 * pro ovládání časovače, který po svém uplynutí způsobí restart.
 */
class AutorebootManager {
  /**
   * @param {Logger} logger
   * @param {number} minInterval
   * @param {PowerManager} powerManager
   * @param {Timers} timers
   */
  constructor(logger, minInterval, powerManager, timers) {
    this.interval = null;
    this.logger = logger;
    this.minInterval = minInterval;
    this.onTimeout = this.onTimeout.bind(this);
    this.powerManager = powerManager;
    this.timeout = null;
    this.timers = timers;
  }

  /**
   * Zjistí, v jakém intervalu se právě provádí automatický reboot.
   * Pokud, není žádný restart naplánovaný, vrací se `null`.
   * @returns {null|number}
   */
  getInterval() {
    return this.interval;
  }

  /**
   * Zjistí, jestli se provádí automatický restart.
   * @returns {boolean}
   */
  isStarted() {
    return !isNil(this.timeout);
  }

  /**
   * Reakce na uplynutí časovače automatického restartu.
   * @private
   * @returns {undefined}
   */
  onTimeout() {
    new Promise((resolve) => resolve(this.powerManager.reboot())).catch(
      (error) => this.logger.error(error)
    );
  }

  /**
   * Spustí automatický restart.
   * @param {number} interval
   * @returns {undefined}
   */
  start(interval) {
    if (this.isStarted()) {
      throw new Error('Autoreboot is already started.');
    }
    const safeDelay = Math.max(this.minInterval, interval);
    this.interval = interval;
    this.timeout = this.timers.setTimeout(this.onTimeout, safeDelay);
  }

  /**
   * Zastaví automatický restart.
   * @returns {undefined}
   */
  stop() {
    this.timers.clearTimeout(this.timeout);
    this.interval = null;
    this.timeout = null;
  }
}

export default AutorebootManager;
